import React, { useEffect } from "react";
import { motion } from "framer-motion";
import GLightbox from "glightbox";
import { gallery } from "../Data";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: "easeOut",
    },
  },
};

const galleryContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.2,
    },
  },
};

const Gallery = () => {
  useEffect(() => {
    const lightbox = GLightbox({
      selector: ".gallery-lightbox",
      touchNavigation: true,
      loop: true,
    });

    return () => {
      lightbox.destroy();
    };
  }, []);

  return (
    <section className="gallery-section container">
      <motion.p
        className="section-subheading"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
        }}
        variants={fadeUp}
      >
        Inside Our Centre
      </motion.p>

      <motion.h2
        className="section-heading"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
        }}
        variants={fadeUp}
      >
        A glimpse into our healing spaces and amenities.
      </motion.h2>

      <motion.div
        className="gallery-grid"
        variants={galleryContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.1,
        }}
      >
        {gallery.map((item, i) => (
          <motion.a
            key={i}
            href={item.img}
            className="gallery-lightbox"
          >
            <motion.div
              className="gallery-card"
              whileHover={{
                y: -5,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              <div
                style={{
                  overflow: "hidden",
                  height: "100%",
                }}
              >
                <motion.img
                  src={item.img}
                  alt={`A glimpse into our healing spaces and amenities. ${i + 1} | Dr. Jigar Gor's Ayurveda`}
                  whileHover={{
                    scale: 1.05,
                  }}
                  transition={{
                    duration: 0.8,
                  }}
                />
              </div>
            </motion.div>
          </motion.a>
        ))}
      </motion.div>
    </section>
  );
};

export default Gallery;